<template>
  <div class="select-wrapper">
    <h2>{{ $props.question }}</h2>
    <div class="options-outer-wrapper">
      <div class="options-inner-wrapper">
        <div class="description">{{ $t("multiple-option-description") }}</div>
        <div
          class="selection grow"
          v-for="(el, i) in $props.selections"
          :key="i"
          @click="onSelect(el)"
          :class="{ 'selected-option': el.selected }"
          :style="{
            'min-width': selectionMinWidth,
            'margin-top': marginSelected(el),
            'margin-bottom': marginSelected(el)
          }"
        >
          <h3 class="selection-name">{{ el.name }}</h3>
          <font-awesome-icon
            v-if="el.selected"
            class="icon icon-yes grow hide-on-mobile"
            :icon="['fas', 'check']"
          />
        </div>
        <one-button
          type="primary"
          class="next-btn"
          @click.native="$props.next()"
        >
          {{ $t(anySelected ? "next" : "skip") }}
        </one-button>
      </div>
      <div>
        <div class="select-image-wrapper shadow">
          <img class="select-image" :src="image" :alt="$props.question" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SelectMultipleInput",
  props: {
    question: {
      type: String,
      required: true
    },
    image: {
      type: String,
      required: true
    },
    selections: {
      type: Array,
      required: true
    },
    clickedCallback: {
      type: Function,
      required: true
    },
    next: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      screenWidth: window.innerWidth
    };
  },
  computed: {
    anySelected() {
      return this.$props.selections.find(s => s.selected) !== undefined;
    },
    selectionMinWidth() {
      let maxLength = 0;
      this.$props.selections.forEach(s => {
        if (s.name.length > maxLength) maxLength = s.name.length;
      });
      const minWidth = maxLength * 10 + 30;
      if (minWidth >= this.screenWidth - 40) {
        return "90%";
      }
      return minWidth + "px";
    }
  },
  created() {
    window.addEventListener("resize", this.widthChanged);
  },
  destroyed() {
    window.removeEventListener("resize", this.widthChanged);
  },
  methods: {
    onSelect(selection) {
      this.$props.clickedCallback(selection);
    },
    marginSelected(el) {
      return el.selected ? "5px" : "7px";
    },
    widthChanged() {
      this.screenWidth = window.innerWidth;
    }
  }
};
</script>

<style scoped lang="scss">
@import "../common/_variables.scss";

.select-image-wrapper {
  border-radius: 10px;
  max-width: 450px;
}
.select-image {
  max-width: 450px;
  width: 100%;
  border-radius: 10px;
  display: block;
}
.selected-image {
  border: 4px solid $color-primary;
}

.options-outer-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  margin-top: 50px;
  /*background-color: #CCC;*/
}
.options-outer-wrapper > div {
  width: 100%;
}

.options-inner-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.selection {
  padding: 10px;
  text-align: left;
  border: 1px solid $color-primary;
  border-radius: 8px;
  background-color: #e5f3f4;
  margin-left: 10px;
  margin-right: 10px;
  color: $color-primary;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.selection-name {
  margin: 0;
}

.selected-option {
  border-width: 3px;
}

.description {
  color: $color-primary;
  font-weight: bold;
  margin-bottom: 20px;
}

@media only screen and (max-width: 768px) {
  .options-outer-wrapper {
    flex-direction: column;
    margin-top: 15px;
  }

  .options-inner-wrapper {
    margin-bottom: 20px;
    order: 0;
  }

  .select-image-wrapper {
    box-shadow: unset;
    width: 100%;
    max-width: 100%;
  }

  .select-image {
    width: 100%;
    max-width: 100%;
  }

  .description {
    margin-top: 10px;
    margin-bottom: 20px;
  }

  .selection {
    margin-bottom: 5px;
  }

  .next-btn {
    margin-top: 25px;
    margin-bottom: 25px;
  }
}
</style>
